import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/plus-jakarta-sans/800.css";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// A home chega com a primeira tela já em HTML (gerada no build): o React só "adota" esse HTML, sem refazer a tela.
// Em qualquer outro caminho, ou se o HTML não estiver lá, monta do zero como sempre.
if (container.hasAttribute("data-ssr") && window.location.pathname === "/") {
  hydrateRoot(container, app);
} else {
  container.removeAttribute("data-ssr");
  createRoot(container).render(app);
}
